import React, { Component } from 'react';
import gf_logo from '../asset/img/gf_logo.png';
import PropTypes from 'prop-types';

export default class Header extends Component{

	render(){
		let headStyle;
		if(this.props.login){
			headStyle = "mt0 mb0 br4 br--top fl w-100 pb3";
		}else{
			headStyle = "mb0 mt0 br4 bb b--gray br--top fl w-100 pb5";
		}
		const imgStyle = {
											minWidth:'75px',
											minHeight:'27px',
											maxWidth:'75px',
											maxHeight:'27px',
											marginLeft:'27px',
											marginTop:'27px'
											};
		const hStyle = {
									backgroundColor:'#357edd',backgroundImage:'linear-gradient(to right,#00449E,#357edd)',
									color:'white', height:'100%'
								};
		return(
			<div className={headStyle} style={hStyle}>
			<img src={gf_logo} alt="logo" style={imgStyle} className="mr2"/>
				<div className="fl w-100 tc pl2 pr2 mt0">
					<p className = "bn tc titleFont light-gray b br2 br--top mt0 mb0 ml3">{this.props.title}</p>
				</div>
			</div>
		);
	}
}

Header.propTypes = {
	login: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/component/Header.js